import './index.scss';
// import starSvg from '../../assets/icons/star.svg';
import sparklesSvg from '../../assets/icons/sparkles.svg';
// import duoSvg from '../../assets/icons/duo.svg';
import { useEffect, useRef, useState } from 'react';
import { AppCircularProgress } from '../../components/AppCircularProgress';
import { useApiHelper } from './apiHelper';
import downloadIconSvg from '../../assets/icons/download.svg';
import { showAlert } from '../../reduxActions/alert';
import {
  useAppDispatch,
  useAppSelector,
} from '../../storeHook';
// import uplLogo from '../../assets/images/upl_logo.png';
// import { SamplePrompts } from './SamplePrompts';
import { ChatHistory } from './chatHistory';
import {
  useLazyGetChatHistoryListQuery,
} from '../../services/agrocraftArtisan';
import { TGetChatHistoryListResponse } from '../../utils/types/agrocraftArtisan';
import TelegramIcon from '@mui/icons-material/Telegram';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import {
  CUSTOM_EVENTS,
  appLogEvent,
} from '../../utils/analytics';
import { ImageToPrompt } from './imageToPrompt';
import { useSearchParams } from 'react-router-dom';
import { LanguageSelect } from '../../components/languageSelect';
import { PromptToImageLoader } from './promptToImageLoader';
import { AspectRatio } from './promptSelections/aspectRatio';
import { ImageStyle } from './promptSelections/imageStyle';
import { ImageUpscale } from './imageUpscale';
import { ZoomOut } from './zoomOut';
import Tooltip from '@mui/material/Tooltip';
import AgriPixLogo from '../../assets/icons/AgriPix_logo.svg';
import { ImageWithQuery } from './imageWithQuery';

// import { EditImage } from './editImage';
const FEATURE_CARDS = {
  light: [
    {
      icon: sparklesSvg,
      title: 'Ad Banners',
      description:
        'To Create advertisement banners in 2mins',
    },
  ],
  dark: [
    {
      icon: sparklesSvg,
      title: 'Stock Images',
      description: 'Create stock images in a jiffy!',
    },
  ],
};
const placeholders: Record<string, string> = {
  en: 'E.G.- A farmer driving a red tractor through a golden wheat field under a clear blue sky',
  pt: 'E.X. - Um fazendeiro dirigindo um trator vermelho por um campo de trigo dourado sob um céu azul claro',
  es: 'E.J. - Un granjero conduce un tractor rojo a través de un campo de trigo dorado bajo un cielo azul claro',
  fr: 'E.X. - Un fermier conduisant un tracteur rouge à travers un champ de blé doré sous un ciel bleu clair',
};

export const AgrocraftArtisian: React.FC = () => {
  const [prompt, setPrompt] = useState('');
  const [language, selectedLanguage] = useState('');
  const [aspectRatio, setAspectRatio] = useState('1:1');
  const [imageStyle, setImageStyle] = useState('realistic');
  const [chatHistoryList, setChatHistoryList] = useState<
    TGetChatHistoryListResponse[] | undefined
  >();
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [
    isLoadingImageToPrompt,
    setIsLoadingImageToPrompt,
  ] = useState(false);
  const [isScrollToLatest, setIsScrollToLatest] =
    useState(true);
  const [imageLoadingStates, setImageLoadingStates] =
    useState<Record<string, boolean>>({});
  const [imageErrorStates, setImageErrorStates] =
    useState<Record<string, boolean>>({});
  const [isLoadingFromHistory, setIsLoadingFromHistory] =
    useState(false);
  const [previousSessionId, setPreviousSessionId] = useState<
    number | undefined
  >(undefined);
  const [justCompletedGeneration, setJustCompletedGeneration] =
    useState(false);
  const [isZoomOutCompleted, setIsZoomOutCompleted] = useState(false);
  const hasHandledInitialLoad = useRef(false);
  // const [isEditingInProgress, setIsEditingInProgress] =
  //   useState<boolean>(false);
  // const [url, setUrl] = useState<string>('');
  const handleLanguageChange = (newValue: string) => {
    selectedLanguage(newValue);
  };
  const [getChatHistoryList] =
    useLazyGetChatHistoryListQuery();
  const dispatch = useAppDispatch();
  const {
    isLoadingImages,
    responseChat,
    downloadImage,
    handleNewSession,
    // chatHistoryList,
    sessionId,
    setSessionId,
    handleLoadMoreChat,
  } = useApiHelper();
  const theme = useAppSelector(
    (state) => state.theme.theme
  );

  const [searchParams] = useSearchParams();
  const userId = searchParams.get('userId');
  const handleHistoryList = () => {
    getChatHistoryList({ fetchedForUserId: userId })
      .unwrap()
      .then((res) => {
        setChatHistoryList(res);
      })
      .catch((err) => {
        console.error('error', err);
        // this.utility.handleError(err);
      });
  };

  useEffect(() => {
    handleHistoryList();
  }, []);

  useEffect(() => {
    if (sessionId !== undefined && sessionId !== previousSessionId && previousSessionId !== undefined) {
      setIsLoadingFromHistory(true);
      setImageLoadingStates({});
      setImageErrorStates({});
      hasHandledInitialLoad.current = false; // Reset for new thread
    }
    if (sessionId === undefined && previousSessionId !== undefined) {
      setIsLoadingFromHistory(false);
      hasHandledInitialLoad.current = false; // Reset when going to "New Prompt"
    }
    setPreviousSessionId(sessionId);
  }, [sessionId, previousSessionId]);

  useEffect(() => {
    if (
      !hasHandledInitialLoad.current &&
      sessionId !== undefined &&
      responseChat.length > 0 &&
      !isLoadingFromHistory &&
      !justCompletedGeneration
    ) {
      setIsLoadingFromHistory(true);
      setImageErrorStates({});
      hasHandledInitialLoad.current = true;
    }
  }, [responseChat, sessionId, isLoadingFromHistory, justCompletedGeneration]);

  const latestChat = responseChat?.[responseChat.length - 1];
  const latestChatImages = latestChat?.ChatContents || [];
  const latestChatImagePaths = latestChatImages
    .map((img) => img.Content?.image_link || '')
    .filter((path) => path !== '');

  const hasLoadingOrPendingImages = latestChatImagePaths.length > 0 &&
    latestChatImagePaths.some(
      (path) =>
        imageLoadingStates[path] === true ||
        imageLoadingStates[path] === undefined
    );

  const shouldShowMainLoader = isLoadingImages ||
    (justCompletedGeneration && latestChatImages.length > 0 && hasLoadingOrPendingImages && !isLoadingFromHistory) ||
    (isZoomOutCompleted && latestChatImages.length > 0 && hasLoadingOrPendingImages && !isLoadingFromHistory);

  const shouldShowHistoryLoader = isLoadingFromHistory &&
    latestChatImages.length > 0 &&
    hasLoadingOrPendingImages;

  const onSubmit = () => {
    setIsScrollToLatest(true);
    if (prompt.split(' ').length < 5) {
      dispatch(
        showAlert({
          content: 'Prompt should be more than 5 words',
          severity: 'error',
        })
      );
      return;
    }
    appLogEvent(CUSTOM_EVENTS.PROMPT_SUBMITTED, {
      prompt,
      aspectRatio,
      imageStyle,
      sessionId,
    });
    setJustCompletedGeneration(false);
    handleNewSession(
      prompt,
      aspectRatio,
      imageStyle,
      sessionId
    ).then((res) => {
      if (res) {
        setPrompt('');
        setJustCompletedGeneration(true);
      }
    });
  };

  const onInputKeyDown = (
    e: React.KeyboardEvent<HTMLTextAreaElement>
  ) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      onSubmit();
      e.preventDefault();
    }
    if (e.key !== 'Enter' && !prompt) {
      appLogEvent(CUSTOM_EVENTS.STARTED_TYPING_A_PROMPT);
    }
  };
  const selectedFeatureCards =
    theme === 'dark'
      ? FEATURE_CARDS.dark
      : FEATURE_CARDS.light;
  const ref = useRef<null | HTMLDivElement>(null);
  const scrollToLatestChat = () => {
    const lastChildElement = ref.current?.lastElementChild;
    lastChildElement?.scrollIntoView({
      behavior: 'smooth',
      block: 'end',
      inline: 'nearest',
    });
  };

  useEffect(() => {
    if (responseChat?.length > 0 && isScrollToLatest) {
      scrollToLatestChat();
    }
  }, [responseChat]);

  const loadMoreImagesHandler = (chatId: number) => {
    setIsScrollToLatest(true);
    setJustCompletedGeneration(false);
    handleLoadMoreChat(
      chatId,
      aspectRatio,
      prompt,
      imageStyle
    ).then((res) => {
      if (res) {
        handleHistoryList();
        setJustCompletedGeneration(true);
      }
    });
  };

  useEffect(() => {
    const textareaEle = textareaRef.current;
    if (textareaEle) {
      textareaEle.style.height = 'auto'; // Reset height to auto to recalculate
      let scrollHeight = textareaEle.scrollHeight;
      if (scrollHeight < 55 || prompt.length < 50) {
        scrollHeight = 44;
      }
      textareaEle.style.height = `${scrollHeight}px`;
    }
  }, [prompt]);

  const handleImageLoadingChange = (
    imagePath: string,
    isLoading: boolean
  ) => {
    setImageLoadingStates((prev) => {
      const newState = {
        ...prev,
        [imagePath]: isLoading,
      };
      return newState;
    });
  };

  useEffect(() => {
    if (isLoadingFromHistory && latestChatImagePaths.length > 0) {
      // Check if at least one image has reported its state
      const someImagesReported = latestChatImagePaths.some(
        (path) => imageLoadingStates[path] !== undefined
      );
      // Hide loader when all images have finished loading (all are false)
      const allImagesFinished = latestChatImagePaths.every(
        (path) => imageLoadingStates[path] === false
      );
      if (someImagesReported && allImagesFinished) {
        setIsLoadingFromHistory(false);
      }
    }
  
    if (justCompletedGeneration && latestChatImagePaths.length > 0) {
      // Check if at least one image has reported its state
      const someImagesReported = latestChatImagePaths.some(
        (path) => imageLoadingStates[path] !== undefined
      );
      // Hide loader when all images have finished loading (all are false)
      const allImagesFinished = latestChatImagePaths.every(
        (path) => imageLoadingStates[path] === false
      );

      if (someImagesReported && allImagesFinished) {
        setJustCompletedGeneration(false);
        // Refresh history list for new/short conversations (e.g. first prompt in a new thread)
        if (responseChat.length < 3) {
          setTimeout(() => {
            handleHistoryList();
          }, 1000);
        }
      }
    }

    if (isZoomOutCompleted && latestChatImagePaths.length > 0) {
      const hasAnyLoadingOrPending = latestChatImagePaths.some(
        (path) =>
          imageLoadingStates[path] === true ||
          imageLoadingStates[path] === undefined
      );
      if (!hasAnyLoadingOrPending) {
        setIsZoomOutCompleted(false);
      }
    }
  }, [imageLoadingStates, isLoadingFromHistory, latestChatImagePaths, justCompletedGeneration, isZoomOutCompleted]);

  const handleImageErrorChange = (
    imagePath: string,
    hasError: boolean
  ) => {
    setImageErrorStates((prev) => ({
      ...prev,
      [imagePath]: hasError,
    }));
  };

  return (
    <>
      <PromptToImageLoader isLoading={shouldShowMainLoader} />
      {isLoadingImageToPrompt && <AppCircularProgress />}
      {shouldShowHistoryLoader && (
        <div className="history-loader-overlay">
          <AppCircularProgress />
        </div>
      )}
      <div className="agrocraft-artisian-container">
        <ChatHistory
          userId={userId}
          setSessionId={setSessionId}
          chatHistoryList={chatHistoryList}
          activeSessionId={sessionId}
          onAfterDelete={handleHistoryList}
        />
        <div className="content-box flex flex-col overflow-y-auto justify-between">
          {responseChat && responseChat?.length > 0 ? (
            <div className="response-chain" ref={ref}>
              {responseChat.map((responseImgs, index) => {
                const chatContents =
                  responseImgs?.ChatContents || [];
                return (
                  <div
                    key={`${responseImgs?.Prompt}-${index}`}>
                    <div className="images-container">
                      {chatContents.map((img, imgIndex) => {
                        const chatContentId = img?.Content?.image_id;
                        return (
                          <div
                            key={`${index}-${imgIndex}-${img.Content?.image_link}`}
                            className="image-wrapper">
                            <ImageWithQuery
                              imagePath={
                                img.Content?.image_link
                              }
                              onLoadingChange={(isLoading) =>
                                handleImageLoadingChange(
                                  img.Content?.image_link || '',
                                  isLoading
                                )
                              }
                              onErrorChange={(hasError) =>
                                handleImageErrorChange(
                                  img.Content?.image_link || '',
                                  hasError
                                )
                              }
                              hideLoader={
                                shouldShowMainLoader || shouldShowHistoryLoader
                              }
                            />
                            {!imageLoadingStates[
                              img.Content?.image_link || ''
                            ] &&
                              !imageErrorStates[
                              img.Content?.image_link || ''
                              ] && (
                                <section className="image-actions">
                                  {!userId && (
                                    <ImageUpscale
                                      img={img}
                                      chatId={responseImgs.ChatId}
                                      setIsScrollToLatest={
                                        setIsScrollToLatest
                                      }
                                    />
                                  )}
                                  {!userId &&
                                    sessionId &&
                                    responseImgs.Prompt &&
                                    'outpaint_flag' in
                                    img.Content && (
                                      <ZoomOut
                                        img={img.Content}
                                        sessionId={sessionId}
                                        setIsScrollToLatest={
                                          setIsScrollToLatest
                                        }
                                        prompt={
                                          responseImgs.Prompt
                                        }
                                        chatId={
                                          responseImgs.ChatId
                                        }
                                        onZoomOutComplete={() => {
                                          setIsZoomOutCompleted(true);
                                          setImageLoadingStates({});
                                          setImageErrorStates({});
                                        }}
                                      />
                                    )}
                                  {/* {!userId && (
                              <EditImage
                                imgURL={
                                  img.Content?.image_link
                                }
                              />
                            )} */}
                                  <Tooltip title="Download image">
                                    <a
                                      onClick={() => {
                                        downloadImage(
                                          img.Content?.image_link,
                                          chatContentId
                                        );
                                      }}
                                      target="_self"
                                      download>
                                      <img
                                        src={downloadIconSvg}
                                      />
                                    </a>
                                  </Tooltip>
                                </section>
                              )}
                          </div>
                        );
                      })}
                    </div>
                    {!userId &&
                      responseChat?.length - 1 === index &&
                      responseImgs?.LoadMore && (
                        <div className="load-more-img--container m-2.5">
                          Unhappy with the results -{' '}
                          <a
                            className="load-more-img--cta"
                            onClick={() => {
                              loadMoreImagesHandler(
                                responseImgs?.ChatId
                              );
                            }}>
                            Load more images
                          </a>
                        </div>
                      )}
                    <div className="ml-3 width-800">
                      <div className="mt-5">
                        {
                          responseImgs?.ChatContents?.[0]
                            ?.Content?.caption
                        }
                      </div>
                      <div className="mt-3">
                        {responseImgs['Prompt']}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="agro-craft-artisan">
              <div className="flex flex-col items-center">
                <img
                  src={AgriPixLogo}
                  alt="App Logo"
                  className="w-[159.49px] h-[45.25px] object-contain"
                />
              </div>
              <div className="flex gap-x-5 mt-7 ag-cards justify-center">
                {selectedFeatureCards.map((card) => (
                  <div
                    key={card.title}
                    className="feature-card">
                    {/* <img src={card.icon} /> */}
                    <div className="feature-icon-box">
                      <AutoAwesomeOutlinedIcon />
                    </div>
                    <div className="font-medium text-[18px] mt-3">
                      {card.title}
                    </div>
                    <div className="description">
                      {card.description}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {!userId && (
            <div className="samples-and-input">
              <div className="flex justify-between items-end text-blue_2f80ed mb-4">
                <div className="flex gap-3">
                  <AspectRatio
                    selectedValue={aspectRatio}
                    onChange={(val) => setAspectRatio(val)}
                  />
                  <ImageStyle
                    selectedValue={imageStyle}
                    onChange={(val) => setImageStyle(val)}
                  />
                  <ImageToPrompt
                    setPrompt={setPrompt}
                    setIsLoadingImageToPrompt={
                      setIsLoadingImageToPrompt
                    }
                  />
                </div>
                {/* <SamplePrompts /> */}
              </div>
              <div className="input-field">
                <LanguageSelect
                  onChange={handleLanguageChange}
                />
                <div className="vertical-line" />
                <textarea
                  id="prompt-textarea"
                  ref={textareaRef}
                  dir="auto"
                  rows={1}
                  className="m-0 w-full resize-none border-0
                py-[10px] max-h-[25dvh] pl-3 pr-4"
                  spellCheck="true"
                  placeholder={placeholders[language]}
                  value={prompt}
                  onChange={(e) => {
                    const sanitized =
                      e.target.value.replace(
                        /[^a-zA-Z0-9 ?.]/g,
                        ''
                      );
                    setPrompt(sanitized);
                  }}
                  onKeyDown={onInputKeyDown}
                />
                <TelegramIcon
                  className="submit-btn"
                  onClick={onSubmit}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
